import type {ExternalStoreThreadListAdapter} from '@assistant-ui/react'

export interface OmicsThreadListAdapterParams {
  threadId: string | null
  threads: ReadonlyArray<{id: string; title: string}>
  onSwitchToThread: (threadId: string) => void
  onSwitchToNewThread: () => void
  onRename?: (threadId: string, newTitle: string) => void
  onDelete?: (threadId: string) => void
}

/** Thin wrapper around assistant-ui's unstable threadList adapter. */
export function buildOmicsThreadListAdapter(
  params: OmicsThreadListAdapterParams,
): ExternalStoreThreadListAdapter {
  const {threadId, threads, onSwitchToThread, onSwitchToNewThread, onRename, onDelete} = params
  return {
    threadId: threadId ?? undefined,
    threads: threads.map((t) => ({
      id: t.id,
      title: t.title || 'New chat',
      status: 'regular' as const,
    })),
    onSwitchToThread,
    onSwitchToNewThread,
    onRename,
    onDelete,
  }
}

/**
 * React key for `useExternalStoreRuntime`. assistant-ui applies the external-store adapter in
 * `useEffect` (after paint); shrinking message/part indexes on a still-mounted runtime throws
 * `tapClientLookup`. Each open tab keeps its own runtime, and convertMessage pads parts to a
 * high-water mark. This key remounts one tab's runtime after cancel or a detected index shrink.
 */
export function omicsThreadRuntimeRemountKey(
  conversationId: string | null,
  threadResyncKey: number,
): string {
  return `${conversationId ?? 'none'}:${threadResyncKey}`
}
